"use strict";
exports.__esModule = true;
var ChartMeasureRow_1 = require("./ChartMeasureRow");
var ChartMeasure = /** @class */ (function () {
    function ChartMeasure(_a) {
        var id = _a.id, color = _a.color, customFormulaType = _a.customFormulaType, displayOrder = _a.displayOrder, type = _a.type, label = _a.label, position = _a.position, percentage = _a.percentage, sql = _a.sql, rows = _a.rows;
        var _this = this;
        this.toJSON = function () { return ({
            id: _this.id,
            color: _this.color,
            customFormulaType: _this.customFormulaType,
            displayOrder: _this.displayOrder,
            type: _this.type,
            label: _this.label,
            position: _this.position,
            percentage: _this.percentage,
            sql: _this.sql,
            rows: _this.rows
        }); };
        this.id = id;
        this.color = color;
        this.customFormulaType = customFormulaType;
        this.displayOrder = displayOrder;
        this.type = type;
        this.label = label;
        this.position = position;
        this.percentage = percentage;
        this.sql = sql;
        this.rows = rows;
    }
    ChartMeasure.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, color = _a.color, customFormulaType = _a.customFormulaType, displayOrder = _a.displayOrder, type = _a.type, label = _a.label, position = _a.position, percentage = _a.percentage, sql = _a.sql, rows = _a.rows;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (color && typeof color !== 'string')
            throw new Error('.color must be a string');
        if (displayOrder && typeof displayOrder !== 'number')
            throw new Error('.displayOrder must be a number');
        if (customFormulaType && customFormulaType !== 'CUMULATIVE_TOTAL' && customFormulaType !== 'WEIGHTED_AVERAGE')
            throw new Error('.color must be a ChartCustomFormulaType');
        if (type !== 'COMBINATION' && type !== 'BAR' && type !== 'LINE' && type !== 'SINGLE_VALUE' && type !== 'TABLE')
            throw new Error('.type must be a ChartType');
        if (typeof label !== 'string')
            throw new Error('.label must be a string');
        if (position && position !== 'LEFT' && position !== 'RIGHT')
            throw new Error('.position must be a ChartTicksPosition');
        if (percentage && typeof percentage !== 'boolean')
            throw new Error('.percentage must be a boolean');
        if (sql && typeof sql !== 'string')
            throw new Error('.sql must be a string');
        var _rows = rows ? rows.map(function (item) { return ChartMeasureRow_1["default"].fromJSON(item); }) : undefined;
        return new ChartMeasure({
            id: id,
            color: color,
            customFormulaType: customFormulaType,
            type: type,
            label: label,
            position: position,
            percentage: percentage,
            sql: sql,
            rows: _rows
        });
    };
    return ChartMeasure;
}());
exports["default"] = ChartMeasure;
